import { createContext } from 'react'

export const EmocionesContext = createContext()
